const PAGINATION_DIVIDER = '...';

export const getPaginationItems = (
  totalPages: number,
  currentPage: number,
  sideItemsToShow: number = 1,
  maxItemsToShow: number,
) => {
  const paginationItems = [];
  const doubleSides = sideItemsToShow * 2;
  if (totalPages <= maxItemsToShow) {
    for (let i = 1; i <= totalPages; i++) {
      paginationItems.push(i);
    }
  } else if (currentPage <= doubleSides) {
    for (let i = 1; i <= doubleSides + 1; i++) {
      paginationItems.push(i);
    }
    paginationItems.push(PAGINATION_DIVIDER, totalPages);
  } else if (currentPage > totalPages - doubleSides) {
    paginationItems.push(1, PAGINATION_DIVIDER);
    for (let i = totalPages - doubleSides; i <= totalPages; i++) {
      paginationItems.push(i);
    }
  } else {
    paginationItems.push(1);
    if (currentPage > doubleSides + (sideItemsToShow % 2 === 0 ? 0 : 1)) {
      paginationItems.push(PAGINATION_DIVIDER);
    }
    for (let i = currentPage - sideItemsToShow; i <= currentPage + sideItemsToShow; i++) {
      if (i > 1 && i < totalPages) {
        paginationItems.push(i);
      }
    }
    if (currentPage < totalPages - doubleSides + (sideItemsToShow % 2 === 0 ? 1 : 0)) {
      paginationItems.push(PAGINATION_DIVIDER);
    }
    paginationItems.push(totalPages);
  }
  return paginationItems;
};
